import React, { useState } from 'react';
import { Container, Paper, TextField, Button, Typography, Alert } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Login = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const { login, loading } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const result = await login(credentials);
    if (result.success) navigate('/');
    else setError(result.error);
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" align="center" gutterBottom>📚 Library Login</Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <form onSubmit={handleSubmit}>
          <TextField fullWidth label="Username" margin="normal" value={credentials.username} onChange={(e) => setCredentials({ ...credentials, username: e.target.value })} required />
          <TextField fullWidth label="Password" type="password" margin="normal" value={credentials.password} onChange={(e) => setCredentials({ ...credentials, password: e.target.value })} required />
          <Button fullWidth variant="contained" type="submit" disabled={loading} sx={{ mt: 2 }}>{loading ? 'Logging in...' : 'Login'}</Button>
          <Typography align="center" sx={{ mt: 2 }}>Don't have an account? <Link to="/register">Register</Link></Typography>
        </form>
      </Paper>
    </Container>
  );
};

export default Login;
